import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount.ts';
import { useCreateStripeClient } from '@/hooks/useCreateStripeClient.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { layoutQueryParams } from '@/pages/Onboarding/Layouts/OwnAIMan_SPaE/params.ts';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../../OwnAIMan/types';

import {
  Card,
  LogoLarge,
  LogoMedium,
  LogoSmall,
  QuoteImg,
  Text,
} from './Social.styles';

export const OnboardingScreenSocial: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Social',
      });
    }

    layoutQueryParams.removeStepsData();
  }, []);

  const { wizard } = useOnboarding();

  const { createStripeClient, isCreatingStripeClient } =
    useCreateStripeClient();

  const form = useFormContext<LayoutDataType>();

  const formEmail = form.watch('email');

  const { refreshUser } = useAccount();

  const handleNextStep = async (): Promise<void> => {
    try {
      const lowerCaseEmail = formEmail.toLowerCase().trim();

      trackOnboardingComplete({ email: lowerCaseEmail });

      await createStripeClient(lowerCaseEmail);
      await userService.createOrUpdate({
        onboarding_data: {
          onboarded: true,
        },
      });

      refreshUser();
    } catch (error) {
      console.error('Can not create a stripe user', error);
    }
  };

  const handleBackStep = () => {
    wizard.goToStep('email');
  };

  return (
    <OnboardingPage className="onboarding-loneliness">
      <OnboardingNavigation onBack={handleBackStep} />

      <OnboardingTitle className="title">They talk about us!</OnboardingTitle>

      <IonContent>
        <Card>
          <Text>
            ...Dialogue has attracted 1.04 million early adopters with 150,000
            monthly active users...
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoLarge src={'/assets/yahoo-logov2.png'} alt="logo" />
        </Card>
        <Card>
          <Text>
            ...Dialogue delivers an experience that feels genuinely personal.
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoSmall src={'/assets/usa-today-logo.png'} alt="logo" />
        </Card>
        <Card>
          <Text>
            ...Dialogue is a virtual BFF who’s always ready to chat...
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoMedium src={'/assets/tech-9ullion-logo.png'} alt="logo" />
        </Card>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        disabled={isCreatingStripeClient}
      />
    </OnboardingPage>
  );
};
